import React, {useEffect, useReducer, useRef, useState} from "react";
import {healthOverviewReducer} from "./QuestionnaireTableReducer";
import { Tooltip } from "flowbite-react";
import NavBar from "../widgets/NavBar";
import Card from "../widgets/Card";
import {VasculiteForm} from "./CustomForms";
import {Tab, Tabs} from "../widgets/Tabs";
import {QuestionaireTable} from "./QuestionaireTable";
import {questionnaire} from "../metaDataProcessed";
import {DefaultButton, SmallButton} from "../widgets/Buttons";
import ModalPopup from "../widgets/ModalPopup";
import {useNavigate, useParams} from "react-router-dom";
import {useApi} from "../ApiSession";
import {useWindowSize} from "../hooks";
import GenderDisplay from "./GenderDisplay";
import {Step} from "../widgets/Stepper";
import Link from "../widgets/Link";


const sectionsQuestionnaire = [
    questionnaire.children[0],
    questionnaire.children[1],
    questionnaire.children[2],
    questionnaire.children[3],
    questionnaire.children[4]
]


export const Questionnaire = ({}) => {

    const navigate  = useNavigate()

    const { dossierId } = useParams();

    const [dossier, setDossier] = useState(null)

    const [isEditVasculiteForm, setIsEditVasculiteForm] = useState(false)

    const [windowWidth, windowHeight] = useWindowSize()

    const navbarRef = useRef(null)

    const [requiredTableTopMargin, setRequiredTableTopMargin] = useState(0)

    const [needResize, setNeedResize] = useState(0)

    const [roundHistoryVisible, setRoundHistoryVisible] = useState(false)

    const api = useApi()

    const [healthOverviewState, healthOverviewDispatch] = useReducer(
        healthOverviewReducer
    )

    const [currentRound, setCurrentRound] = useState(null)

    useEffect(() => {
        if(navbarRef.current) {
            setRequiredTableTopMargin(navbarRef.current.offsetHeight + 10)
        }
    }, [`${windowWidth},${windowHeight},${navbarRef.current ? 'null': 'not-null'},${needResize}`])

    useEffect(() => {
        api.getDossier(dossierId).then(res => {
            setDossier(res)

            res.rounds.forEach((round, idx) => {
                //console.log(round, idx)
                round.visit_label = idx === 0 ? "1ere saisie": `${idx+1}e saisie`
            })

            healthOverviewDispatch({name: "init", dossier: res})
            const currentRound = res.rounds[res.rounds.length -1]
            setCurrentRound(currentRound)
            healthOverviewDispatch({
                name: "setVisibleSection",
                visibleSectionLabel: sectionsQuestionnaire[0].label
            })
            setNeedResize(1)
        })
    },[])

    if(healthOverviewState && healthOverviewState.rounds.length === 0) {
        throw Error(`empty rounds`)
    }

    const popEditVasculiteForm = () =>
        <ModalPopup
                marginTop={200}
                title={"Infos sur la Vasculite"}
                onClose={() => setIsEditVasculiteForm(false)}
            >
                <VasculiteForm
                    mode={'edit'}
                    dossier={dossier}
                    currentRound={currentRound}
                    onSave={_dossier => {
                        api.updateDossier(_dossier).then(res => {
                            setIsEditVasculiteForm(false)
                            setDossier({
                                ..._dossier,
                                rounds: dossier.rounds
                            })
                        })
                    }}
                    onCancel={() => setIsEditVasculiteForm(false)}
                />
            </ModalPopup>

    if(!dossier) {
        return <h1>Loading</h1>
    }

    const edit = () =>
        setIsEditVasculiteForm(true)


    const GridCell = ({children}) =>
        <div className={"mt-4 mb-4"} onClick={edit}>
            {children}
        </div>


    const popRoundHistory = () =>  roundHistoryVisible &&
        <ModalPopup
                marginTop={200}
                title={"Historique des Saisies"}
                onClose={() => setRoundHistoryVisible(false)}
            >
            <ol className="relative text-gray-500 border-s border-gray-200 dark:border-gray-700 dark:text-gray-400">
                {
                    dossier.rounds.map((r, idx) => {

                        const isCompleted = idx < (dossier.rounds.length - 1)
                        const completeOrInProgressTxt = isCompleted ? `complétée` : `en cours...`

                        return <Step
                            key={`k-${idx}`}
                            title={`${idx+1}e saisie du questionnaire (${completeOrInProgressTxt})`}
                            isCompleted={isCompleted}
                            details={
                                <span>Visite du {r.visit_date}</span>
                            }
                        />
                    }
                    )
                }
            </ol>

            </ModalPopup>


    return <>
        {popRoundHistory()}
        <NavBar refz={navbarRef}>
            <Card onClick={() => setIsEditVasculiteForm(true)}>
                <div className="grid grid-cols-4">
                        <GridCell>Sexe: <GenderDisplay genderCode={dossier.gender}/></GridCell>
                        <GridCell>naissance: {dossier.year_of_birth}</GridCell>
                        <GridCell>Début symptômes {dossier.symptoms_start_date}</GridCell>
                        <GridCell>Date diagnostic {dossier.diagnosis_date}</GridCell>
                        <GridCell>Type de Vasculite: {dossier.vasculite_type} {dossier.vasculite_subtype}</GridCell>
                        <GridCell>Notes {dossier.notes}</GridCell>
                        <GridCell><div>Visite, saisie en cours : {currentRound.visit_date}</div>
                        <div>
                            <Link
                                caption={"voir historique"}
                                onClick={
                                e => {
                                    e.stopPropagation()
                                    setRoundHistoryVisible(true)
                                }}
                            />
                        </div>
                        </GridCell>
                        <GridCell>
                            <DefaultButton
                                caption={"Quitter le Questionnaire"}
                                onClick={() => navigate("/")}
                            />
                        </GridCell>
                </div>
            </Card>
            <Tabs>
                    {
                        sectionsQuestionnaire.map(
                            section => {

                                if(!section) {
                                    debugger
                                }

                                let tabCounter =
                                    healthOverviewState.observationCountPerTab[section.label]

                                let tabCounterLabel = ""

                                if(tabCounter > 0) {
                                    tabCounterLabel = ` (${tabCounter}) `
                                }
                                else if(healthOverviewState.viewedTabForLastRound[section.label]) {
                                    tabCounterLabel = " (0)"
                                }

                                const renderTabTool = () => {
                                    if(tabCounterLabel === "") {
                                        return "Vous n'avez pas parcouru cette section du questionnaire"
                                    }
                                    else if (tabCounterLabel === " (0)") {
                                        return "Vous avez parcouru cette section du questionnaire, mais saisi aucune donnée."
                                    }

                                    return `Vous avez saisi ${healthOverviewState.observationCountPerTab[section.label]} éléments de questionnaire dans cette section.`

                                }

                                return <Tooltip content={renderTabTool()} key={section.id}>
                                        <Tab
                                        className="me-2"
                                        key={section.id}
                                        label={section.label + tabCounterLabel}
                                        isSelected={healthOverviewState.visibleSectionLabel === section.label}
                                        onClick={() => {
                                            healthOverviewDispatch({
                                                name: "setVisibleSection",
                                                visibleSectionLabel: section.label
                                            })
                                        }}
                                    />
                                </Tooltip>
                            }
                        )
                    }
            </Tabs>
        </NavBar>
        <div style={{marginTop: requiredTableTopMargin+30}}></div>
        <div className="flex flex-row">
        <div className={"basis-1/5"}></div>
            <div className={"basis-3/5"}>
                <QuestionaireTable
                    dossier={dossier}
                    currentRound={currentRound}
                    healthOverviewState={healthOverviewState}
                    healthOverviewDispatch={healthOverviewDispatch}
                />
            </div>
            <div className={"basis-1/5"}></div>
        </div>
        {isEditVasculiteForm && popEditVasculiteForm()}
    </>

}